import React from 'react';
import { ROUTES } from '../helpers/constants';
import CloseIcon from '../assets/close-icon';

export const SectionError = ({ refetch, isWithInfoText = true, classNames }) => {
  return (
    <div className={`px-8 ${classNames}`}>
      {isWithInfoText && (
        <h3 className="font-semibold text-base mb-2">Maaf, telah terjadi kesalahan di server</h3>
      )}
      <span className={`text-base inline-flex gap-2 justify-center items-center cursor-pointer text-[#0898C9] ${classNames}`}>
        <b onClick={refetch}>Muat ulang</b>
      </span>
    </div>
  );
};

const Error = ({ refetch, onBack }) => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 px-10">
      {!!onBack && (
        <button className="mb-2 md:mb-0 self-end" onClick={onBack}>
          <CloseIcon />
        </button>
      )}
      <img src="/coming-soon.png" alt="-" className="mb-8" />
      {!!onBack ? (
        <SectionError refetch={refetch} isWithInfoText={false} />
      ) : (
        <>
          <h1 className="font-semibold text-3xl">Maaf, telah terjadi kesalahan di server</h1>
          <h2 className="text-base">
            Kembali ke{' '}
            <a href={ROUTES.home} className="text-[#0898C9]">
              <b>Beranda</b>
            </a>
            , atau coba{' '}
            <b onClick={refetch} className="text-[#0898C9] cursor-pointer">
              muat ulang
            </b>
          </h2>
        </>
      )}
    </div>
  );
};

export default Error;
